// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as CardsSDK$OrcaPaymentPage from "./CardsSDK.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as VaultHelpers$OrcaPaymentPage from "./VaultHelpers.bs.js";

function PaymentMethodsSDK(props) {
  let sessions = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.sessions);
  let setVaultCredentials = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  let isConfigReady = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isConfigReady);
  let isSavedCardCvcFlow = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isSavedCardCvcFlow);
  React.useEffect(() => {
    setVaultCredentials(param => VaultHelpers$OrcaPaymentPage.getVaultCredentialsFromSessions(sessions));
  }, [sessions]);
  return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
    condition: isConfigReady,
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(CardsSDK$OrcaPaymentPage.make, {
        cvcOnly: isSavedCardCvcFlow
      }),
      style: {
        padding: "2px"
      }
    })
  });
}

let make = PaymentMethodsSDK;

export {
  make,
}
/* jotai Not a pure module */
